<template>
  <div
    class="bg-[var(--fundoForm)] w-full p-2 rounded-md flex justify-center items-center text-[var(--text)]"
  >
    <form
      @submit.prevent="uploadDocument"
      class="flex flex-col items-left gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2"
    >
      <h1 style="color: var(--titulo)">Repositorio</h1>

      <div class="w-full grid grid-cols-2 items-center gap-1">
        <label for="tipo" style="color: var(--label)">Tipo:</label>
        <select
          v-model="tipo"
          required
          class="rounded-md p-1 text-black"
          :class="{ 'input-required': !tipo }"
        >
          <option disabled value="">Selecione o tipo</option>
          <option v-for="tipo in tipos" :key="tipo.id" :value="tipo.id">
            {{ tipo.nome }}
          </option>
        </select>
      </div>

      <FormInput
        v-model="nome"
        id="nome"
        label="Nome:"
        :placeholder="nomePlaceholder"
        required
        class="rounded-md p-1"
      />

      <FormInput
        v-model="referencia"
        id="referencia"
        label="Referência:"
        :placeholder="referenciaPlaceholder"
        class="rounded-md p-1"
      />
      <div class="w-full grid grid-cols-2 items-center gap-1">
        <label for="documento" style="color: var(--label)">Documento:</label>
        <input
          type="file"
          @change="handleFileUpload"
          required
          class="rounded-md p-1"
          :class="{ 'input-required': !documento }"
        />
      </div>

      <div class="flex justify-end gap-2 mt-2">
        <button
          v-if="validPermission('C0047')"
          @click.prevent="toggleDocumentList"
          class="px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-white"
        >
          Ver Documentos
        </button>

        <button
          v-if="validPermission('C0012')"
          type="submit"
          class="px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-white"
        >
          Upload
        </button>
      </div>
    </form>
  </div>

  <!-- Lista de Documentos -->
  <div v-if="showDocumentList" class="mt-4 flex-1 overflow-y-auto">
    <div v-if="documentos.length > 0">
      <AppTable
        :visibility="true"
        :show="true"
        :table_data="documentos"
        :acoes-column="acoesColumn"
        @view-documento="handleView"
        @delete-row="handleDelete"
        table_title="Documentos Salvos"
        @row-clicked="select_documento"
        @close="toggleDocumentList"
        :show_multiSelect="false"
      />
    </div>
    <div v-else class="text-center text-[var(--text)] no-documents-message">
      Nenhum documento encontrado.
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppButton from "@/components/button.vue";
import AppTable from "@/components/tables/table.vue";
import FormInput from "@/components/FormInput.vue";

export default {
  name: "documentos",
  components: {
    AppButton,
    AppTable,
    FormInput,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      tipos: [],
      tipo: "",
      nome: "",
      referencia: "",
      documento: null,
      documentos: [],
      showDocumentList: false, // Controle de visibilidade,
      acoesColumn: {
        show: true,
        label: "Ações", // optional, defaults to 'Ações'
        actions: [
          {
            icon: "fa-regular fa-eye",
            emit: "view-documento",
            color: "white", // optional
            title: "Ver documento", // optional tooltip
          },
          {
            icon: "fa-solid fa-trash",
            emit: "delete-row",
            color: "red",
            title: "Eliminar",
          },
        ],
      },
    };
  },
  computed: {
    nomePlaceholder() {
      const tipoSelecionado = this.tipos.find((tipo) => tipo.id === this.tipo);
      return tipoSelecionado
        ? `Nome do documento (${tipoSelecionado.nome})`
        : "Nome do documento";
    },
    referenciaPlaceholder() {
      const tipoSelecionado = this.tipos.find((tipo) => tipo.id === this.tipo);
      return tipoSelecionado
        ? `Referência do documento (${tipoSelecionado.nome})`
        : "Referência do documento";
    },
  },
  async created() {
    await this.fetchTipos();
  },
  methods: {
    async fetchTipos() {
      try {
        const res = await axios.get(`${this.baseURL}/api/v1/tprepositorio/`);
        this.tipos = res.data.data;
      } catch (error) {
        console.error("Error fetching tipos:", error);
      }
    },
    // async fetchDocumentos() {
    //     try {
    //         const res = await axios.get(`${this.baseURL}/api/v1/documentoempresa/`);
    //         this.documentos = res.data.data;
    //     } catch (error) {
    //         console.error('Error fetching documentos:', error);
    //     }
    // },
    async fetchDocumentos() {
      try {
        const res = await axios.get(`${this.baseURL}/api/v1/repositorio/`);
        this.documentos = res.data.data.map((doc) => {
          const tipo = this.tipos.find(
            (tipo) => tipo.id === doc.tpRepositorio_id,
          );
          return {
            id: doc.id,
            tipoRepositorio: tipo ? tipo.nome : "Tipo desconhecido",
            nome: doc.nome,
            referencia: doc.referencia,
          };
        });
      } catch (error) {
        console.error("Error fetching documentos:", error);
      }
    },

    handleFileUpload(event) {
      this.documento = event.target.files[0];
    },
    async uploadDocument() {
      if (!this.documento || this.tipo === "" || this.nome === "") {
        return;
      }

      const formData = new FormData();
      formData.append("tpRepositorio_id", this.tipo);
      formData.append("referencia", this.referencia);
      formData.append("nome", this.nome);
      formData.append("documento", this.documento);

      try {
        const res = await axios.post(
          `${this.baseURL}/api/v1/repositorio/registrar/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.data.status == 200 || res.data.status == 201) {
          this.resetForm();
          this.showDocumentList = true;
          await this.fetchDocumentos();
        } else {
          console.error("Erro ao enviar documento");
        }
      } catch (error) {
        console.error("Error uploading document:", error);
      }
    },
    resetForm() {
      this.documento = null;
      this.nome = "";
      this.referencia = "";
      this.tipo = "";
    },
    toggleDocumentList() {
      this.showDocumentList = !this.showDocumentList;
      if (this.showDocumentList) {
        this.fetchDocumentos();
      }
    },
    select_documento(documento) {},
    validPermission(permission) {
      return true;
    },
    handleView(documento) {
      const schema = localStorage.getItem("selectedSchema");
      if (!schema) {
        return;
      }
      const url = `${this.baseURL}/api/v1/repositorio/viewall/${documento.id}/?schema=${schema}`;
      window.open(url, "_blank");
    },
    async handleDelete(documento) {
      const schema = localStorage.getItem("selectedSchema");
      if (!schema) {
        return;
      }
      if (confirm("Tem certeza que deseja eliminar este documento?")) {
        try {
          const res = await axios.delete(
            `${this.baseURL}/api/v1/repositorio/eliminar/${documento.id}/`,
          );
          if (res.data.status == 200) {
            this.fetchDocumentos();
          } else {
            console.error("Erro ao eliminar documento");
          }
        } catch (error) {
          console.error("Error deleting document:", error);
        }
      }
    },
  },
};
</script>

<style scoped>
input[type="file"],
select,
input[type="text"] {
  border-radius: 5px;
  padding: 0.5rem;
  border: 1px solid #cccccc;
  font-size: 0.875rem;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 0.5rem;
  border: 1px solid #cccccc;
  text-align: left;
  font-size: 0.875rem;
}

thead {
  background-color: #4e73df;
  color: white;
}

tbody tr:hover {
  background-color: #f8f9fc;
}

.no-documents-message {
  text-align: center;
  color: #ff9b05;
  font-size: 0.875rem;
}

.text-black {
  color: var(--text);
}
</style>
